import React from 'react';
import { formatValueIfNullOrUndefined, formatDate, clearFormat } from 'utilities/util';
import { PropertiesRibbonWrapper } from 'components/properties-ribbon';

interface ITopBarOwnProps {
    quantity: string;
    weight: string;
    shipmentType: string;
    volume: string;
    packages: string;
    sealNumber1: string;
    createdDate: string;
    lastUpdated: string;
}

export const DetailsTopBar: React.FunctionComponent<ITopBarOwnProps> = (props) => {
    const propertiesRibbonData = {
        labels: [
            { label: 'Quantity', value: formatValueIfNullOrUndefined(props.quantity), key:`equipments-quantity`  },
            { label: 'Weight', value: formatValueIfNullOrUndefined(clearFormat(props.weight, 3)), key:`equipments-weight`  },
            { label: 'Volume', value: `${formatValueIfNullOrUndefined(clearFormat(props.volume, 3))}`, key:`equipments-volume` },
            { label: 'Packages', value: formatValueIfNullOrUndefined(props.packages), key:`equipments-packages` },
            { label: '', value: '', key:`equipments-space`},
            { label: 'Shipment type', value: formatValueIfNullOrUndefined(props.shipmentType), key:`equipments-shipmentType` },
            { label: 'Created date', value: formatDate(props.createdDate, 'YYYY-MM-DD hh:mm'), key:`equipments-createdDate` },
            { label: 'Last Update date', value: formatDate(props.lastUpdated, 'YYYY-MM-DD hh:mm'), key:`equipments-lastUpdated` }
        ],
        actions: [],
        isActionHidden: true
    }
    return (
        <React.Fragment>
            <PropertiesRibbonWrapper content={propertiesRibbonData} key={`-BookingDetailsTopBar-${Math.random()}`}/>
        </React.Fragment>
    )
};